// extracted by mini-css-extract-plugin
module.exports = {"input-error":"InputErrorText_input-error__uIjgo"};